export { OrderTemplates as default } from "./order-templates";
